import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { memo } from "react";
import { computeRatio, updateScrollPosition } from "./utils";
import "./ThumbBar.less";
import { jsx as _jsx } from "react/jsx-runtime";
function ThumbBar(_ref) {
  var visible = _ref.visible,
    isGlobal = _ref.isGlobal,
    trackStyle = _ref.trackStyle,
    thumbStyle = _ref.thumbStyle,
    minThumbSize = _ref.minThumbSize,
    start = _ref.start,
    gap = _ref.gap,
    horizontal = _ref.horizontal,
    pin = _ref.pin,
    trackRef = _ref.trackRef,
    boxSize = _ref.boxSize,
    update = _ref.update;
  var CW = boxSize.CW,
    CH = boxSize.CH,
    PT = boxSize.PT,
    PR = boxSize.PR,
    PB = boxSize.PB,
    PL = boxSize.PL,
    SW = boxSize.SW,
    SH = boxSize.SH;
  var _ref2 = horizontal ? ["width", CW, SW] : ["height", CH, SH],
    _ref3 = _slicedToArray(_ref2, 3),
    sizeKey = _ref3[0],
    offsetSize = _ref3[1],
    scrollSize = _ref3[2];
  function getContainerBox() {
    var _trackRef$current, _trackRef$current$par;
    var targetNode = (_trackRef$current = trackRef.current) === null || _trackRef$current === void 0 ? void 0 : (_trackRef$current$par = _trackRef$current.parentNode) === null || _trackRef$current$par === void 0 ? void 0 : _trackRef$current$par.parentNode;
    return targetNode === document.body ? document.documentElement : targetNode;
  }
  function handleThumbBarClick(e) {
    var containerBox = getContainerBox();
    var scrollLeft = containerBox.scrollLeft,
      scrollTop = containerBox.scrollTop;
    var scrollPosition = horizontal ? scrollLeft : scrollTop;
    var rect = e.target.getBoundingClientRect();
    var clickPosition = horizontal ? (e.clientX - rect.left) / rect.width : (e.clientY - rect.top) / rect.height;
    var scrollRatio = scrollPosition / scrollSize;
    var position = clickPosition > scrollRatio ? Math.min(scrollSize, scrollPosition + offsetSize) : Math.max(0, scrollPosition - offsetSize);
    updateScrollPosition(containerBox, position, horizontal);
  }
  function handleStart(e) {
    e.stopPropagation();
    var _getContainerBox = getContainerBox(),
      scrollLeft = _getContainerBox.scrollLeft,
      scrollTop = _getContainerBox.scrollTop;
    update({
      pinX: horizontal,
      pinY: !horizontal,
      lastST: scrollTop,
      lastSL: scrollLeft,
      startX: e.clientX,
      startY: e.clientY
    });
  }
  var style = _objectSpread(_objectSpread({}, isGlobal ? _defineProperty({}, sizeKey, gap > 0 ? "calc(100% - ".concat(gap, "px)") : undefined) : _objectSpread(_defineProperty({}, sizeKey, offsetSize - gap), horizontal ? {
    bottom: -PB,
    left: -PL + start
  } : {
    top: PT - gap + start,
    right: -PR,
    transform: "translateY(-100%)"
  })), trackStyle && trackStyle(horizontal));
  return /*#__PURE__*/_jsx("div", {
    className: "ms-track".concat(horizontal ? " ms-x" : " ms-y").concat(pin ? " ms-active" : visible ? " ms-track-show" : ""),
    onClick: handleThumbBarClick,
    ref: trackRef,
    style: style,
    children: /*#__PURE__*/_jsx("div", {
      className: "ms-thumb",
      onMouseDown: handleStart,
      onClick: function onClick(e) {
        return e.stopPropagation();
      },
      style: _objectSpread(_defineProperty({}, sizeKey, computeRatio(scrollSize, offsetSize, gap, minThumbSize).thumbSize), thumbStyle && thumbStyle(horizontal))
    })
  });
}
export default /*#__PURE__*/memo(ThumbBar);